export default function($input) {
	var replacementVal = $input.dataset.value
	$input.value = replacementVal
}
